import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { ImportWizard } from "@/components/migration/ImportWizard";
import { getImporter } from "@/migration/registry";
import type { EntityKey } from "@/migration/engine/types";

export const Route = createFileRoute("/_authenticated/settings/import/$entity")({
  head: ({ params }) => ({
    meta: [
      { title: `Importer ${params.entity} | VERQO` },
      { name: "description", content: "Guidet import fra CSV-fil." },
    ],
  }),
  component: ImportEntityPage,
  errorComponent: ({ error }) => (
    <div className="p-6 text-sm text-destructive">Feil: {String(error)}</div>
  ),
  notFoundComponent: () => (
    <div className="p-6 text-sm text-muted-foreground">Importer ikke funnet.</div>
  ),
});

function ImportEntityPage() {
  const { entity } = Route.useParams();
  const importer = getImporter(entity as EntityKey);
  if (!importer) throw notFound();

  return (
    <div className="space-y-4">
      <Link to="/settings/import" className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="w-4 h-4 mr-1" /> Tilbake til dataimport
      </Link>
      <PageHeader
        title={`Importer ${importer.label.toLowerCase()}`}
        subtitle={importer.description}
      />
      <ImportWizard importer={importer} />
    </div>
  );
}
